import { useEffect, useState } from 'react';

function isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function deepMergeDefaults(defaults, stored) {
    if (!isPlainObject(defaults)) {
        return stored !== undefined ? stored : defaults;
    }
    if (!isPlainObject(stored)) {
        return defaults;
    }

    const result = { ...defaults };
    for (const key of Object.keys(defaults)) {
        if (!(key in stored)) continue;
        const defaultValue = defaults[key];
        const storedValue = stored[key];
        if (isPlainObject(defaultValue) && isPlainObject(storedValue)) {
            result[key] = deepMergeDefaults(defaultValue, storedValue);
        } else if (storedValue !== undefined) {
            result[key] = storedValue;
        }
    }
    return result;
}

export function loadSessionState(key, defaults) {
    if (typeof sessionStorage === 'undefined') {
        return defaults;
    }
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return defaults;
        const parsed = JSON.parse(raw);
        return deepMergeDefaults(defaults, parsed);
    } catch {
        return defaults;
    }
}

export function saveSessionState(key, state) {
    if (typeof sessionStorage === 'undefined') return;
    try {
        sessionStorage.setItem(key, JSON.stringify(state));
    } catch {
        // Ignore quota / private-mode failures
    }
}

export function useSessionListState(key, defaults) {
    const [state, setState] = useState(() => loadSessionState(key, defaults));

    useEffect(() => {
        saveSessionState(key, state);
    }, [key, state]);

    return [state, setState];
}
